export default function () {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let autoId = '';
    const array = new Uint8Array(20);
    crypto.getRandomValues(array);
    array.forEach(byte => {
        autoId += chars[byte % chars.length];
    });
    return autoId;
}
